module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-standard@2x.bdbc2ca9.png" + "?" + Date.now();